import { ModuleWithProviders, Provider } from '@angular/core';
import { DwUserService } from '@webdpt/framework';
import { FxDapHttpClient } from './http/fx-http-client';
import { FxDapHttpErrorHandler } from './http/fx-http-error-handler';
var FxDapModule = /** @class */ (function () {
    function FxDapModule() {
    }
    FxDapModule.forRoot = function (providers) {
        if (providers === void 0) { providers = []; }
        return {
            ngModule: FxDapModule,
            providers: [
                FxDapHttpErrorHandler,
                FxDapHttpClient,
                {
                    provide: DwUserService
                }
            ].concat(providers)
        };
    };
    return FxDapModule;
}());
export { FxDapModule };
